import axios from 'axios'
import store from '@/store'
import storage from 'store'
import notification from 'ant-design-vue/es/notification'
import {VueAxios} from './axios'
import {ACCESS_TOKEN, TENANT, TOKEN_NAME} from '@/store/mutation-types'

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 6000 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  console.log('errorHandler', error.response)
  if (error.response) {
    const data = error.response.data
    // 从 localstorage 获取 token
    const token = storage.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message
      })
    }
    if (error.response.status === 404) {
      console.log('404')
      notification.error({
        message: '404',
        description: data.message
      })
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      notification.error({
        message: 'Unauthorized',
        description: 'Authorization verification failed'
      })
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    }
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/json;charset=UTF-8'
  const tokenName = storage.get(TOKEN_NAME)
  const token = storage.get(ACCESS_TOKEN)
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    config.headers[tokenName] = token
  }
  const tenant = storage.get(TENANT)
  if (tenant) {
    config.headers['tenant'] = tenant
  }
  if (!config.headers.device) {
    config.headers.device = 'web'
  }
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  if (response.request.responseType === 'blob') {
    return response
  }
  if (response?.data?.success) {
    return response.data
  }
  const resData = response.data
  const code = response.data.code
  if (code === 1011006 || code === 1011007 || code === 1011008 || code === 1011009 || code === 1111022 || code === 1111023) {
    store.dispatch('Logout')
      .catch(() => {
        window.location.reload()
      })
      .finally(() => window.location.reload())
  }
  notification.error({
    message: '请求异常',
    description: resData.message
  })
  return Promise.reject(response.data)
}, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}
